/* stylelint-disable */
import React, { useEffect, useState } from "react"

import cn from "classnames"
import { connectHierarchicalMenu } from "react-instantsearch-dom"
import { useIntl } from "react-intl"

import arrow from "./arrow.svg"
import Link from "~/components/Link/Link"
import { Body } from "~/components/ui"
import useIsClient from "~/hooks/useIsClient"

// eslint-disable-next-line css-modules/no-unused-class
import css from "./CustomHierarchicalMenu.module.scss"

const HierarchicalMenu: React.FC<
  any & {
    items: any[]
    refine: (value: any) => any
    baseItems: any
    limit: number
  }
> = props => {
  const {
    items,
    currentRefinement,
    refine,
    createURL,
    showResetButton = false,
    baseItems,
    limit,
  } = props
  const intl = useIntl()

  const isClient = useIsClient()

  const formatItems = (items: any[]): any[] => {
    if (items) {
      const filteredChildrenItems = items.map((item: any) => {
        const filteredChildren = item.items ?? []

        return {
          ...item,
          items: filteredChildren.length ? filteredChildren : null,
        }
      })

      if (filteredChildrenItems.length) {
        const withChildrenItems = filteredChildrenItems.filter(
          (item: any) => item.items?.length
        )

        const result = withChildrenItems.length
          ? withChildrenItems
          : filteredChildrenItems
        result.sort(itemsOrderer)
        return result
      }
    }
    return []
  }

  const itemsOrderer = (a: any, b: any) => {
    const aValue = a.label ?? a.value ?? ""
    const bValue = b.label ?? b.value ?? ""

    return aValue > bValue ? 1 : aValue < bValue ? -1 : 0
  }

  const [displayedItems, setDisplayedItems] = useState(
    formatItems(baseItems?.items ?? items ?? [])
  )

  useEffect(() => {
    const newItems = formatItems(items)
    if (newItems.length) {
      setDisplayedItems(newItems)
    }
  }, [items, currentRefinement])

  const resetCategoriesHandler = (event: any) => {
    event.preventDefault()
    refine("")
  }

  return (
    <div
      className={cn(css.HierarchicalMenu, {
        [css.subLevel]: !showResetButton && !currentRefinement,
      })}
    >
      {showResetButton && currentRefinement && (
        <Body variant="body2" semiBold className={css.allCategories}>
          <Link
            to={`/${intl.locale}${createURL("")}`}
            absoluteLink
            onClick={resetCategoriesHandler}
          >
            <img src={arrow} alt="back" className={css.arrowIcon} />{" "}
            {intl.formatMessage({
              id: "category/text:all-categories",
            })}
          </Link>
        </Body>
      )}
      {displayedItems.map(function (item: any, index: number) {
        if (item.label) {
          if (!isClient && item.count < 5) {
            return null
          }

          const isParent =
            item.items?.filter((i: { items: any }) => i.items).length > 0

          const refinedChildren = item.items?.filter(
            (childFilter: any) => childFilter.isRefined
          )
          const isLastRefined =
            item.isRefined && (!refinedChildren || refinedChildren.length == 0)

          return (
            <div key={index}>
              <Body
                variant="body2"
                bold={isParent || item.isRefined}
                semiBold={!isParent && !item.isRefined}
                className={css.CategoryText}
              >
                <Link
                  to={`/${intl.locale}${createURL(item.value)}`}
                  absoluteLink
                  onClick={event => {
                    event.preventDefault()

                    // item.items is undefined going down
                    const goBack = !!item.items

                    const hasChildRefined = !!items.filter(
                      (itemOfItems: { isRefined: any }) => itemOfItems.isRefined
                    )

                    let goValue = item.value

                    if (goBack && hasChildRefined) {
                      const childRefined = items.filter(
                        (itemOfItems: { isRefined: any }) =>
                          itemOfItems.isRefined
                      )[0]
                      // If his childRefined has a childRefined, we have to go to his value
                      const childRefinedOfChildRefined =
                        childRefined.items.filter(
                          (itemOfItems: { isRefined: any }) =>
                            itemOfItems.isRefined
                        )[0] ?? null

                      if (childRefinedOfChildRefined) {
                        goValue = childRefinedOfChildRefined.value
                        refine(goValue)
                      }
                    } else {
                      refine(goValue)
                    }
                  }}
                  className={cn({ [css.selectText]: isLastRefined })}
                >
                  {item.label}
                  {!item.items && ` (${item.count})`}
                </Link>
              </Body>
              {item.items && (
                <HierarchicalMenu
                  items={item.items}
                  refine={refine}
                  createURL={createURL}
                  limit={limit}
                />
              )}
            </div>
          )
        }
      })}
    </div>
  )
}

const CustomHierarchicalMenu = connectHierarchicalMenu(HierarchicalMenu)

export default CustomHierarchicalMenu
